export default "__VITE_ASSET__ASroVng1__"